/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


(function () {
  var el = document.querySelector('.top-fv-splide');
  if (!el || typeof Splide === 'undefined') return;

  var fv = new Splide(el, {
    type: 'loop',
    perPage: 1,
    speed: 2000,
    interval: 7000,
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false,
    pagination: true,
    reducedMotion: { autoplay: 'play', speed: 0 },
    i18n: {
      select: '表示するスライドを選択',
      slide: 'スライド',
      pageX: '%s ページ目へ',
    },
  });
  fv.mount();
  // 初期化前のCSS（先頭以外を非表示）の影響でクローン幅0のまま開始位置が0pxに計算されるため、初期化後に再計算する（2026-09-15）
  fv.refresh();
})();

// 熨斗オプション

document.addEventListener('DOMContentLoaded', function () {
  var productForms = document.querySelectorAll('.product-form');

  if (!productForms.length) {
    return;
  }

  function toggleNoshiFields(form) {
    var noshiSelect = form.querySelector('#noshi-select');
    var noshiType = form.querySelector('#noshi-type');
    var noshiNaire = form.querySelector('#noshi-naire');
    var noshiName = form.querySelector('#noshi-name');
    var detailsArea = form.querySelector('.noshi-details');
    var nameArea = form.querySelector('.noshi-name-area');

    if (!noshiSelect || !detailsArea || !nameArea) {
      return;
    }

    var hasNoshi = noshiSelect.value === '外熨斗' || noshiSelect.value === '内熨斗';
    detailsArea.style.display = hasNoshi ? 'block' : 'none';

    var nameRequiredBadge = nameArea ? nameArea.querySelector('.noshi-required') : null;

    if (!hasNoshi) {
      if (noshiType) {
        noshiType.selectedIndex = 0;
        noshiType.disabled = true;
        noshiType.required = false;
      }
      if (noshiNaire) {
        noshiNaire.selectedIndex = 0;
        noshiNaire.disabled = true;
      }
      if (noshiName) {
        noshiName.value = '';
        noshiName.required = false;
        noshiName.disabled = true;
      }
      if (nameRequiredBadge) {
        nameRequiredBadge.style.display = 'none';
      }
      nameArea.style.display = 'none';
      return;
    }

    if (noshiType) {
      noshiType.disabled = false;
      noshiType.required = true;
    }
    if (noshiNaire) {
      noshiNaire.disabled = false;
    }

    var needsName = noshiNaire && noshiNaire.value === '記入';
    nameArea.style.display = needsName ? 'block' : 'none';

    if (noshiName) {
      noshiName.disabled = !needsName;
      noshiName.required = !!needsName;
      if (!needsName) {
        noshiName.value = '';
      }
    }
    if (nameRequiredBadge) {
      nameRequiredBadge.style.display = needsName ? 'inline' : 'none';
    }
  }

  productForms.forEach(function (form) {
    var noshiSelect = form.querySelector('#noshi-select');
    var noshiNaire = form.querySelector('#noshi-naire');

    if (!noshiSelect) {
      return;
    }

    toggleNoshiFields(form);
    noshiSelect.addEventListener('change', function () {
      toggleNoshiFields(form);
    });
    if (noshiNaire) {
      noshiNaire.addEventListener('change', function () {
        toggleNoshiFields(form);
      });
    }
  });
});
